import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpService  } from '../../core/services/http/http.service';
import { Seller  } from '../../../store/actions/sellerActions';

@Injectable({
  providedIn: 'root'
})
export class SellerService {

  constructor(private store: Store<any>,private http: HttpService) { }
  seller(){
    return this.http.query('get', 'all-announcements?type=1&min=0&max=5', {});
  }
 
  dispatchSellerAction()
  {
    this.store.dispatch(new Seller());
  }
}